<page-header icon="fas fa-users" header="{{'Users' | translate}}"
             subHeader="{{subheaderTranslation}}">
    <page-header-content>
        <button class="btn btn-border-radius btn-secondary pull-right mt-2"
                monEventTrigger="actionTrigger"
                [monEventParams]="{action: 'add-user-btn'}"
                (click)="addUser()"
                [attr.aria-label]="'Add new user' | translate"
                translate>
                + Add new user
        </button>
    </page-header-content>
</page-header>

<div class="d-flex justify-content-end align-items-center mb-3">
    <csv-export-button clsSize="py-2 px-3" clsMargin="mr-0" [exports]="exports"></csv-export-button>
    <filter-button
            [showFiltersBtn]="showFilters"
            [(isFiltersOpen)]="isFiltersOpen">
    </filter-button>
    <table-search [model]="search"
                  (getPage)="onSearch($event)">
    </table-search>
</div>
<div class="card panel-monsido-card">
    <div class="card-body">
        <table-container
                (onPageChange)="onPageChange($event)"
                (onPerPageChange)="onPageSizeChange($event)"
                [collection]="users"
                [progress]="promise">
            <table-container-top>
                <div class="outer-b merge-r-16 merge-l-16 merge-t-16" *ngIf="isFiltersOpen">
                    <table-filters [(open)]="isFiltersOpen"
                                   [(ngModel)]="filters"
                                   name="filters"
                                   [filters]="availableFilters"
                                   (onChanges)="onFiltersChanges($event)">
                    </table-filters>
                </div>
            </table-container-top>
            <div>
                <admin-users-table (getPage)="getPage()"
                                   [users]="users"
                                   [isAdmin]="true"
                                   [currentSort]="currentSort"
                                   (onPageSort)="onMonTableSort($event)">
                </admin-users-table>
            </div>
        </table-container>
    </div>
</div>
